export * from './geofence-zone.model';
